import Vue from "vue";

const VueYandexMetrika = require('vue-yandex-metrika');

Vue.use(VueYandexMetrika, {
    id: 56244529,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    env: process.env.NODE_ENV
});

export default VueYandexMetrika;